import { shuffle } from './shuffle';
export const colors = {
    black: '#000000',
    white: '#ffffff',
    red: [
        '#ffdbdb',
        '#ffbcbc',
        '#ff9f9f',
        '#ff8383',
        '#ff6a6a',
        '#f95353',
        '#f03e3e',
        '#d42f2f',
        '#b72222',
        '#931717',
        '#6f0e0e',
        '#4a0707',
        '#260303'
    ],
    orange: [
        '#ffe6d9',
        '#ffd0b5',
        '#ffba91',
        '#ffa46c',
        '#ff8f48',
        '#ff7b24',
        '#f76707',
        '#db5700',
        '#b74700',
        '#933800',
        '#6f2900',
        '#4a1b00',
        '#260e00'
    ],
    gold: [
        '#fff3d9',
        '#ffe7b5',
        '#ffdb91',
        '#ffcd6c',
        '#ffbf48',
        '#ffaf24',
        '#f59f00',
        '#db8b00',
        '#b77600',
        '#936100',
        '#6f4a00',
        '#4a3300',
        '#261b00'
    ],
    yellow: [
        '#fffbd9',
        '#fff5b5',
        '#ffee91',
        '#ffe56c',
        '#ffdc4d',
        '#ffd132',
        '#fcc419',
        '#dbac0d',
        '#b79304',
        '#937900',
        '#6f5d00',
        '#4a4000',
        '#262200'
    ],
    lime: [
        '#edfdd9',
        '#dcfab5',
        '#cbf491',
        '#b9ec71',
        '#a7e354',
        '#95d738',
        '#82c91e',
        '#71b314',
        '#5f9a0b',
        '#4d8005',
        '#3a6301',
        '#284500',
        '#152500'
    ],
    green: [
        '#dcf8e1',
        '#bdf0c6',
        '#9fe7ac',
        '#83dc93',
        '#68cf7b',
        '#4fc163',
        '#37b24d',
        '#2b9d3f',
        '#208733',
        '#176f27',
        '#0f561c',
        '#093b12',
        '#041f09'
    ],
    teal: [
        '#d9f7ed',
        '#b5eedb',
        '#91e4c9',
        '#6cd7b6',
        '#48c8a2',
        '#29b88d',
        '#0ca678',
        '#059469',
        '#00805a',
        '#006b4a',
        '#005339',
        '#003a27',
        '#001f14'
    ],
    cyan: [
        '#d9f8fd',
        '#b6eff8',
        '#95e5f2',
        '#77daea',
        '#5acde1',
        '#3fbfd5',
        '#26b0c7',
        '#1b9bb1',
        '#128598',
        '#0a6e7e',
        '#055562',
        '#013a44',
        '#001f24'
    ],
    blue: [
        '#d9ecff',
        '#b5dafe',
        '#91c8fb',
        '#6fb6f5',
        '#51a3ed',
        '#3691e3',
        '#1c7ed6',
        '#116dbe',
        '#095ba5',
        '#034988',
        '#00376a',
        '#00254a',
        '#001326'
    ],
    indigo: [
        '#dce4ff',
        '#becbff',
        '#a1b4ff',
        '#869eff',
        '#6e89fb',
        '#5775f4',
        '#4263eb',
        '#3351d0',
        '#2541b3',
        '#1a3293',
        '#10246f',
        '#09174a',
        '#040b26'
    ],
    violet: [
        '#e7deff',
        '#d0c0ff',
        '#bba4ff',
        '#a78afd',
        '#9472f8',
        '#815cf1',
        '#7048e8',
        '#5d38cd',
        '#4c2ab0',
        '#3b1e91',
        '#2b146f',
        '#1c0b4a',
        '#0e0526'
    ],
    magenta: [
        '#f6ddfc',
        '#edbef8',
        '#e2a1f2',
        '#d786ea',
        '#ca6ce1',
        '#bd54d6',
        '#ae3ec9',
        '#9830b2',
        '#822498',
        '#6a1a7e',
        '#521161',
        '#380a43',
        '#1d0423'
    ],
    pink: [
        '#ffdae7',
        '#fdbad1',
        '#f99bbc',
        '#f37ea7',
        '#eb6393',
        '#e24a7f',
        '#d6336c',
        '#be265b',
        '#a31b4b',
        '#87123b',
        '#690a2b',
        '#48051d',
        '#26020e'
    ],
    gray: [
        '#e3e5e6',
        '#c9cccf',
        '#afb3b7',
        '#959a9f',
        '#7c8287',
        '#62696f',
        '#495057',
        '#3e454b',
        '#34393f',
        '#292e33',
        '#1f2327',
        '#14171a',
        '#0a0c0e'
    ]
};
export const shuffledColors = shuffle([
    ...colors.red.filter((_, key) => key >= 5),
    ...colors.orange.filter((_, key) => key >= 5),
    ...colors.yellow.filter((_, key) => key >= 5),
    ...colors.green.filter((_, key) => key >= 5),
    ...colors.blue.filter((_, key) => key >= 5),
    ...colors.violet.filter((_, key) => key >= 5),
    ...colors.cyan.filter((_, key) => key >= 5),
    ...colors.magenta.filter((_, key) => key >= 5),
    ...colors.gray.filter((_, key) => key >= 5),
    ...colors.indigo.filter((_, key) => key >= 5),
    ...colors.lime.filter((_, key) => key >= 5),
    ...colors.pink.filter((_, key) => key >= 5),
    ...colors.teal.filter((_, key) => key >= 5)
]);
export const colorGradient = (color) => colors[color];
//# sourceMappingURL=colors.js.map